import { render, staticRenderFns } from "./CategoryManual.vue?vue&type=template&id=b4f0c07c"
import script from "./CategoryManual.vue?vue&type=script&lang=js"
export * from "./CategoryManual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports